import { ContactForm } from '../ContactForm';
import { ContactTaskMe } from '../ContactTaskMe';
import { ContactContainer, ContactContent, ContactGrid } from './styles';

export function Contact() {
    return (
        <ContactContent id="contact">
            <ContactContainer>
                <h2>Entrar em contato</h2>
                <p>Vamos tirar sua ideia do papel?</p>
                <ContactGrid>
                    <ContactTaskMe />
                    <ContactForm />
                </ContactGrid>
            </ContactContainer>
        </ContactContent>
    )
}